<rask-container-block [noBorder]="true">
  <rask-header class="flex" size="2">
    <label>
      Leverantörsinformation
      <rask-info>Leverantörsinformationen kan inte ändras efter ett kontrakt i avtalet har skickats till VACS.
        Skapa
        ett nytt avtal för att kunna lägga till andra leverantörer
      </rask-info>
    </label>
    <rask-action-button [disabled]="!writePermission || readonly" icon="fas fa-plus" (click)="createLeverantor()"
      aid="buttonCreateLeverantor">
      Skapa ny leverantör
    </rask-action-button>

    <rask-action-button [disabled]="!writePermission || readonly" icon="fas fa-map" (click)="searchFastighet()">
      Sök via fastighetsregister
    </rask-action-button>

    <rask-action-button [disabled]="!writePermission || readonly" icon="fas fa-search" (click)="searchLeverantor()"
      aid="buttonSearchLeverantor">
      Sök via leverantörsregister
    </rask-action-button>
  </rask-header>

  @if (leverantorer$) {
    <rask-list [data]="leverantorer$ | async">
      <rask-list-column header="Leverantör" field="namn" width="11%">
        <ng-template let-row="row">
          @if (writePermission) {
            <a ngbTooltip="Redigera virkesleverantör" href="javascript: void(0)"
            (click)="openRedigeraLeverantorDialog(row.id, row.guid)">{{ row.namn }}</a>
          } @else {
            {{ getDisplayName(row) }}
          }
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Person/orgnummer" field="persOrgNummer" width="10%"></rask-list-column>
      <rask-list-column header="Kontaktperson" field="kontaktperson" width="9%" [centered]="true">
        <ng-template let-row="row">
          <rask-radiobutton
            [disabled]="!writePermission || readonly"
            [checked]="row.kontaktperson"
            (checkedChange)="setKontaktperson(row)">
          </rask-radiobutton>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Leverantörsnr" field="levNummer" width="10%"></rask-list-column>
      <rask-list-column header="Telefon" width="10%">
        <ng-template let-row="row">
          {{ leverantorPhoneFormatter(row) }}
        </ng-template>
      </rask-list-column>
      <rask-list-column header="E-Postadress" field="epost" width="10%"></rask-list-column>
      <rask-list-column header="Adress" width="10%">
        <ng-template let-row="row">
          {{ leverantorAdressFormatter(row) }}
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Andel" width="10%">
        <ng-template let-row="row" ngbTooltip="Ange kontaktperson">
          {{ leverantorAndelFormatter(row) }}
          <span ngbTooltip="Ändra andel">
            <rask-icon-button
              [ngbPopover]="popoverContentAndel"
              popoverTitle="Ange andel"
              #popoverAndel="ngbPopover"
              [autoClose]="'outside'"
              triggers="manual"
              (click)="popoverAndel.open()"
              icon="far fa-pen"
              [disabled]="readonly">
            </rask-icon-button>
          </span>
          <ng-template #popoverContentAndel>
            <rask-container-block [noBorder]="true">
              <div class="row w-100 justify-content-md-center">
                <rask-input-number [min]="0" class="col-5" #andelTaljare [value]="row.andelTaljare">
                </rask-input-number>
                <div class="col-2 forward-slash">/</div>
                <rask-input-number [min]="0" class="col-5" #andelAndelNamnare [value]="row.andelNamnare">
                </rask-input-number>
              </div>
              <ng-container footer>
                <div class="row w-100 justify-content-md-center">
                  <rask-button class="col-5" color="secondary" (click)="popoverAndel.close()">Avbryt
                  </rask-button>
                  <div class="col-2"></div>
                  <rask-button class="col-5" color="primary"
                    (click)="setAndel(row, andelTaljare.value, andelAndelNamnare.value, popoverAndel)">
                  Ändra</rask-button>
                </div>
              </ng-container>
            </rask-container-block>
          </ng-template>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="Momsregistreringsnummer" width="15%">
        <ng-template let-row="row">
          @if (row.momsnummerEjAktuellt) {
            <div>
              <span ngbPopover="Momsregistreringsnummer är inte aktuellt för denna leverantör"
                triggers="mouseenter:mouseleave">
                Ej aktuellt
              </span>
            </div>
          } @else {
            <span [ngbPopover]="popoverMomsregistreringsnummer" triggers="mouseenter:mouseleave">
              {{ row.momsregistreringsnummer }}
            </span>
            @if (row.momsnummerValideringsstatus !== momsnummerValideringsstatus.giltig) {
              <ng-container
                appendContent>
                <rask-icon
                  [ngbPopover]="popoverMomsregistreringsnummer" triggers="mouseenter:mouseleave"
                  [class]="row.momsnummerValideringsstatus === momsnummerValideringsstatus.ogiltig ? 'red' : 'orange'"
                  [icon]="momsnummerIcon(row)">
                </rask-icon>
              </ng-container>
            }
            <ng-template #popoverMomsregistreringsnummer>
              @if (row.momsnummerValideringsstatus) {
                <div>
                  {{ row.momsnummerValideringsstatus === momsnummerValideringsstatus.ejValiderad ? 'Senaste
                  försök till hämtning från VIES' : 'Senaste hämtning från VIES' }}:
                  <br>{{ row.momsnummerValideringstid | date:'short'}}<br>
                </div>
              }
              {{ momsnummerStatusText(row) }}
            </ng-template>
          }
        </ng-template>
      </rask-list-column>
        <rask-list-column width="5%" header="Överstyr Mätbeskedsadress">
          <ng-template let-row="row">
            @if(isOverstyrMatbeskedActive(row) | async){
              <rask-checkbox
                #overstyrMatbeskedsadressCheckbox
                [checked]="row.overstyrMatbeskedsadress"
                [disabled]="!writePermission"
                (checkedChange)="setOverstyrMatbeskedsadress(row, overstyrMatbeskedsadressCheckbox.value)">
              </rask-checkbox>
            }
          </ng-template>
        </rask-list-column>
      <rask-list-column width="5%">
        <ng-template let-row="row">
          <rask-icon-button ngbTooltip="Ta bort" [disabled]="!writePermission || readonly" icon="far fa-trash-alt"
          negative (click)="removeLeverantor(row)" aid="buttonTaBortLeverantor">Ta bort</rask-icon-button>
        </ng-template>
      </rask-list-column>
    </rask-list>
  }
</rask-container-block>